import { Container, Title, Text, Button, Stack, Paper, Center } from '@mantine/core';
import { IconBrandGithub } from '@tabler/icons-react';
import { useAuth } from '@/hooks/useAuth';
import { Navigate } from 'react-router-dom';

export function HomePage() {
  const { isAuthenticated, signIn, isLoading } = useAuth();

  // Redirect to environments if already authenticated
  if (isAuthenticated) {
    return <Navigate to="/environments" replace />;
  }

  if (isLoading) {
    return (
      <Center h="100vh">
        <Text>Loading...</Text>
      </Center>
    );
  }

  return (
    <Container size="sm" style={{ marginTop: '10vh' }}>
      <Paper p="xl" radius="md" withBorder>
        <Stack gap="lg" align="center">
          <Title order={1}>pk8s.aops.dev</Title>
          <Text size="lg" c="dimmed" ta="center">
            Self-service Kubernetes environment portal
          </Text>
          <Text ta="center">
            Deploy development environments and databases on-demand with automatic cleanup.
          </Text>
          <Button
            leftSection={<IconBrandGithub size={20} />}
            size="lg"
            onClick={signIn}
          >
            Sign in with GitHub
          </Button>
        </Stack>
      </Paper>
    </Container>
  );
}

